import styled from 'styled-components';

export const List = styled.ul`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
